import React from 'react';
import BreakListTableContainer from './BreakListTableContainer.jsx';
import DocumentTitle from 'react-document-title';

const ListBreaksPage = (props) => (
  <DocumentTitle title="Beaker">
    <BreakListTableContainer />
  </DocumentTitle>
);

export default ListBreaksPage;



// WEBPACK FOOTER //
// ./public/pages/ListBreaks/ListBreaksPage.jsx